export default "__VITE_ASSET__WsZFVA44__"